import { DateRange, dateRangesOverlap } from 'owa-datetime-utils';
import { EventEntity } from '../schema/EventEntity';

export function getIndexRangeForEventsInDateRange(events: EventEntity[], dateRange: DateRange) {
    const indexRange = { startIndex: -1, endIndex: -1 };

    for (let i = 0; i < events.length; i++) {
        const doesOverlap = dateRangesOverlap(
            { start: events[i].Start, end: events[i].End },
            dateRange,
            true /* inclusive */
        );

        if (doesOverlap === 0 && indexRange.startIndex === -1) {
            // Its the first event we encountered that overlaps with our date range
            // hences that would be the start index
            indexRange.startIndex = i;
        } else if (doesOverlap !== 0 && indexRange.startIndex !== -1) {
            // Its the first event after our date range that does not overlap hence
            // the previous event was the end index and we stop processing any further processing
            indexRange.endIndex = i - 1;
            break;
        }
    }

    if (indexRange.startIndex !== -1 && indexRange.endIndex === -1) {
        // The last item also overlaped with our date range hence
        // items till end are part of the index range
        indexRange.endIndex = events.length - 1;
    }

    return indexRange;
}
